import { render, staticRenderFns } from "./SecondPage.vue?vue&type=template&id=b9e5475e&scoped=true&"
import script from "./SecondPage.vue?vue&type=script&lang=js&"
export * from "./SecondPage.vue?vue&type=script&lang=js&"
import style0 from "./SecondPage.vue?vue&type=style&index=0&id=b9e5475e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e5475e",
  null
  
)

export default component.exports